import { render, staticRenderFns } from "./loyalty-management.vue?vue&type=template&id=49c5a2db&scoped=true"
import script from "./loyalty-management.vue?vue&type=script&lang=js"
export * from "./loyalty-management.vue?vue&type=script&lang=js"
import style0 from "./loyalty-management.vue?vue&type=style&index=0&id=49c5a2db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c5a2db",
  null
  
)

export default component.exports